/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBNATUREOFPERSON = {
    Club: 'C',
    Society: 'SO',
    OtherCompany: 'OC',
    SchoolOrUniversity: 'SSU',
    StateOwnedEnterprise: 'SOE',
    TestamentaryTrust: 'TT',
    Stokvel: 'STO',
    UnincorporatedBodyOfPersons: 'UBOP',
    ForeignStateOwnedEnterprise: 'FSOE',
    IndividualEstates: 'IE',
    ClosedCorporation: 'CC',
    ForeignUnlistedCompany: 'FUC',
    SpecialTrustA1: 'ST1',
    ForeignIndividual: 'FI',
    UnlistedCompany: 'UC',
    ListedCompany: 'LC',
    CorporateEstateOrLiquidation: 'CE',
    AssociationNotForGain: 'ANFG',
    ForeignTrust: 'FT',
    SpecialTrustA2: 'ST2',
    RetirementFund: 'RF',
    ChurchOrReligiousOrganisation: 'CRO',
    Refugee: 'R',
    AsylumSeeker: 'AS',
    Individual: 'I',
    ForeignListedCompany: 'FLC',
    Trust: 'T'
} as const;
export type GHUBNATUREOFPERSON = typeof GHUBNATUREOFPERSON[keyof typeof GHUBNATUREOFPERSON];


export function GHUBNATUREOFPERSONFromJSON(json: any): GHUBNATUREOFPERSON {
    return GHUBNATUREOFPERSONFromJSONTyped(json, false);
}

export function GHUBNATUREOFPERSONFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBNATUREOFPERSON {
    return json as GHUBNATUREOFPERSON;
}

export function GHUBNATUREOFPERSONToJSON(value?: GHUBNATUREOFPERSON | null): any {
    return value as any;
}

